import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getData,
  getColumns,
  getIsLoading,
} from '../redux/selectors/BalanceOnHandCurrentInfoSelectors';
import ListTable from '../../../../../common/tables/ListTable';
import TableDefinitions from '../../../../../common/TableDefinitions';
import { tableLoadData } from '../../../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getClickedRowOnTable } from '../../../../../common/tables/reducers/selectors/ListTableSelectors';

class BalanceOnHandCurrentInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.props.tableLoadData({ tableId: 'VIEW_BOH_CURRENT_INFO' }, this.props.appContext.appContext, { impcCode: this.props.clickedRow.impc });
  }

  componentDidUpdate(prevProps) {
    if (this.props.clickedRow !== prevProps.clickedRow) {
      this.props.tableLoadData({ tableId: 'VIEW_BOH_CURRENT_INFO' }, this.props.appContext.appContext, { impcCode: this.props.clickedRow.impc });
    }
  }

  render() {
    return (
      <ListTable
        listId={TableDefinitions.VIEW_BOH_CURRENT_INFO.id}
        loading={this.props.isLoading}
        columns={this.props.columns}
        data={this.props.data}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    clickedRow: getClickedRowOnTable(state),
    isLoading: getIsLoading(state),
  };
}

BalanceOnHandCurrentInfoContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  clickedRow: PropTypes.objectOf(PropTypes.shape),
  isLoading: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BalanceOnHandCurrentInfoContainer);
